var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.dialogVisible) ? _c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "margin-top": "40px",
      "margin-left": "40px",
      "font-weight": "600"
    }
  }, [_vm._v("员工档案管理")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "9px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "#FFFFFF",
      "margin": "0px 40px",
      "border": "1px solid #eaebed"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "background-color": "#f7f8fa",
      "height": "750px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('Structure', {
    ref: "Structure",
    attrs: {
      "condition": _vm.condition
    },
    on: {
      "parentFind": _vm.Find
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding-left": "46px",
      "padding-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('span', [_vm._v("所在职位")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "70%",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.condition.post_id),
      callback: function($$v) {
        _vm.$set(_vm.condition, "post_id", $$v)
      },
      expression: "condition.post_id"
    }
  }, _vm._l((_vm.postList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.post_name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "70%",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.condition.staff_name),
      callback: function($$v) {
        _vm.$set(_vm.condition, "staff_name", $$v)
      },
      expression: "condition.staff_name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('span', [_vm._v("身份证号")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "70%",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.condition.staff_card),
      callback: function($$v) {
        _vm.$set(_vm.condition, "staff_card", $$v)
      },
      expression: "condition.staff_card"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t查询")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "180px"
    }
  }, [_c('download-excel', {
    staticClass: "export-excel-wrapper",
    staticStyle: {
      "margin-left": "-180px",
      "top": "100px"
    },
    attrs: {
      "fields": _vm.download_excel,
      "title": "缴纳人员清单",
      "name": "架构人员清单.xls",
      "fetch": _vm.ExportForm
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "goon"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t导表")])], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.openfileUrl()
      }
    }
  }, [_vm._v("导入")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导入",
      "visible": _vm.dialogVisibledr,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibledr = $event
      },
      "close": _vm.closeDialog
    }
  }, [_c('el-upload', {
    ref: "adModel",
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$globals.http + '/file/upload',
      "multiple": "",
      "file-list": _vm.fileList,
      "on-success": _vm.handleAvatarSuccess,
      "on-remove": _vm.handleRemove
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t选择文件")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [(_vm.fileDatatitle) ? _c('div', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("导入失败人员姓名：\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-start",
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.fileData), function(item, index) {
    return _c('div', {
      staticStyle: {
        "flex": "1",
        "width": "calc((100% - 20px) / 5)",
        "min-width": "calc((100% - 20px) / 5)",
        "max-width": "calc((100% - 20px) / 5)"
      }
    }, [_c('div', [_vm._v(_vm._s(item))])])
  }), 0)]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "border": "1px solid #006E4B",
      "margin": "30px 0 0 40%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.savefileUrl()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "0px 2%",
      "margin-top": "10px"
    }
  }, [_c('el-row', [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#F0F0F0',
        color: '#000000'
      },
      "row-class-name": _vm.tableRowClassName,
      "data": _vm.tableData,
      "height": "530",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }], null, false, 1273622649)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_name",
      "align": "center",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_card",
      "align": "center",
      "label": "身份证号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bankuai",
      "align": "center",
      "label": "年龄"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "align": "center",
      "label": "性别"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.staff_gender == '1' ? '男' : '女') + "\n            \t\t\t\t\t\t\t\t")]
      }
    }], null, false, 1261671307)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_telephone",
      "align": "center",
      "label": "手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gangwei",
      "align": "center",
      "label": "招聘方式"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "post_name",
      "align": "center",
      "label": "所在职位"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "induction_time",
      "align": "center",
      "label": "入职时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": require("../../../assets/详情.png")
          },
          on: {
            "click": function($event) {
              return _vm.Edit(scope.row.id)
            }
          }
        })]
      }
    }], null, false, 1153350881)
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.page_size,
      "layout": " prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.dialogVisible) ? _c('div', [_c('edit', {
    ref: "edit"
  })], 1) : _vm._e()])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8457bc6","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ygdagl/YgdaXx/Ygdaxx.vue
// module id = null
// module chunks = 